// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uins-search-icon{position:absolute;left:.5em;top:.5em;width:1.75em;height:1.75em;padding:0;margin:0;z-index:1}.uins-search-icon,.uins-search-icon .search-icon{display:block;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.uins-search-icon .search-icon{position:relative;width:100%;height:100%}.uins-search-icon .search-icon .icon-path{fill:#8d99ae}", ""]);
// Exports
module.exports = exports;
